var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.interviewQuestion.id
      ? _c("input", {
          attrs: {
            name: "interview_questions[" + _vm.index + "][id]",
            type: "hidden",
            required: ""
          },
          domProps: { value: _vm.interviewQuestion.id }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "grid-x grid-padding-x mb-3" }, [
      _c("div", { staticClass: "cell small-12" }, [
        _c("label", { staticClass: "mb-2" }, [_vm._v("Question")]),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x grid-padding-x" }, [
          _c(
            "div",
            { staticClass: "cell auto" },
            [
              _vm.disabled
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.interviewQuestion.title,
                        expression: "interviewQuestion.title"
                      }
                    ],
                    attrs: {
                      disabled: _vm.disabled,
                      name: "interview_questions[" + _vm.index + "][title]",
                      type: "text",
                      required: ""
                    },
                    domProps: { value: _vm.interviewQuestion.title },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.interviewQuestion,
                          "title",
                          $event.target.value
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.disabled
                ? _c("RedactorControl", {
                    attrs: {
                      name: "interview_questions[" + _vm.index + "][title]",
                      value: _vm.interviewQuestion
                        ? _vm.interviewQuestion.title
                        : "",
                      rows: "5"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-x grid-padding-x mb-3 pl-40" }, [
      _c("div", { staticClass: "cell small-5 pl-0 pr-2" }, [
        _c("label", [_vm._v("Question Phase:")]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.interviewQuestion.phase,
                expression: "interviewQuestion.phase"
              }
            ],
            attrs: {
              disabled: _vm.disabled,
              name: "interview_questions[" + _vm.index + "][phase]",
              required: ""
            },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.interviewQuestion,
                  "phase",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              }
            }
          },
          [
            _c("option", { attrs: { value: "First Interview" } }, [
              _vm._v("First Interview")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "Panel Interview" } }, [
              _vm._v("Panel Interview")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "Telephonic Screening" } }, [
              _vm._v("Telephonic Screening")
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cell small-5 pl-4 pr-2" }, [
        _c("label", [_vm._v("Answer Type:")]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.interviewQuestion.answer_type,
                expression: "interviewQuestion.answer_type"
              }
            ],
            attrs: {
              disabled: _vm.disabled,
              name: "interview_questions[" + _vm.index + "][answer_type]",
              required: ""
            },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.interviewQuestion,
                  "answer_type",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              }
            }
          },
          [
            _c("option", { attrs: { value: "free" } }, [
              _vm._v("Free words / explain / discuss")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "rating" } }, [
              _vm._v("Rating (1-5)")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "yes_no" } }, [_vm._v("Yes / No")])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cell small-2 pt-25 pl-0" }, [
        !_vm.disabled
          ? _c(
              "div",
              {
                staticClass: "remove-button",
                on: {
                  click: function() {
                    return _vm.$emit("remove")
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-minus-circle" })]
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-x grid-padding-x mb-4 pl-40" }, [
      _vm.parentQuestions.length > 0
        ? _c("div", { staticClass: "cell pl-0 small-12" }, [
            _c(
              "div",
              {
                staticClass: "form-check form-check-inline form-check-reverse"
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.isTriggered,
                      expression: "isTriggered"
                    }
                  ],
                  staticClass: "form-check-input",
                  attrs: {
                    disabled: _vm.disabled,
                    type: "checkbox",
                    id: "inlineCheckbox1",
                    value: "option1"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.isTriggered)
                      ? _vm._i(_vm.isTriggered, "option1") > -1
                      : _vm.isTriggered
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.isTriggered,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = "option1",
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.isTriggered = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.isTriggered = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.isTriggered = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label",
                    attrs: { for: "inlineCheckbox1" }
                  },
                  [_vm._v("Is Triggered Question?")]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isTriggered
        ? _c("div", { staticClass: "cell small-12" }, [
            _c("div", { staticClass: "grid-x grid-padding-x" }, [
              _c("div", { staticClass: "cell small-6" }, [
                _c("label", [_vm._v("Parent Question:")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.interviewQuestion.parent_id,
                        expression: "interviewQuestion.parent_id"
                      }
                    ],
                    attrs: {
                      disabled: _vm.disabled,
                      name: "interview_questions[" + _vm.index + "][parent_id]",
                      required: ""
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.interviewQuestion,
                          "parent_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.parentQuestions, function(question) {
                    return _c(
                      "option",
                      {
                        key: question.id + "-parent",
                        domProps: { value: question.id }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.removeHtmlTags(question.title)) +
                            "\n                        "
                        )
                      ]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell small-6" }, [
                _c("label", [_vm._v("Answer:")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.interviewQuestion.parent_answer,
                        expression: "interviewQuestion.parent_answer"
                      }
                    ],
                    attrs: {
                      disabled: _vm.disabled,
                      name:
                        "interview_questions[" + _vm.index + "][parent_answer]",
                      required: ""
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.interviewQuestion,
                          "parent_answer",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "yes" } }, [_vm._v("Yes")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "no" } }, [_vm._v("No")])
                  ]
                )
              ])
            ])
          ])
        : _c("input", {
            attrs: {
              name: "interview_questions[" + _vm.index + "][parent_id]",
              type: "hidden",
              value: ""
            }
          }),
      _vm._v(" "),
      !_vm.interviewQuestion.id
        ? _c("div", { staticClass: "cell help-text mt-1" }, [
            _c("small", [
              _vm._v(
                "* You'll need to save progress before being able to use this as a trigger question."
              )
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37a4cd9a", { render: render, staticRenderFns: staticRenderFns })
  }
}